import lockScroll from '../__utils/lockScroll';

const $ = jQuery.noConflict();
class Header {
	constructor(trigger = '.btn-hamburger', pbody = 'body', listParent = '.menu-item-has-children > a', overlayDesktop = '.main-header__overlay', overlayMobile = '.main-header__nav-mobile', header = '.main-header', hamburgerTitle = '.btn-hamburger__title', megaMenuLinks = '.main-header__overlay-nav a', megaMenuImages = '.main-header__overlay-content .menu', animateElements = '.main-header__overlay-nav li, .main-header__overlay-menu .main-header__subnav li, .main-header__overlay-content-image, .main-header__overlay-footer .main-header__subnav') {
		this.trigger = trigger;
		this.pbody = pbody;
		this.listParent = listParent;
		this.overlayMobile = overlayMobile;
		this.overlayDesktop = overlayDesktop;
		this.overlay = null;
		this.header = header;
		this.hamburgerTitle = hamburgerTitle;
		this.megaMenuLinks = megaMenuLinks;
		this.megaMenuImages = megaMenuImages;
		this.animateElements = animateElements;
		this.viewport = window.matchMedia('screen and (min-width: 1200px)');
	}
	init() {
		if (!this.header) return;
		this.checkOverlay();
		$(this.trigger).on('click', { _this: this }, this.setNavState);
		$(this.listParent).on('click', this.setListState);
		this.megaMenuHover();
	}

	checkOverlay() {
		if (this.viewport.matches) {
			this.overlay = this.overlayDesktop;
		} else {
			this.overlay = this.overlayMobile;
		}
	}

	setNavState(e) {
		e.preventDefault();
		const _this = e.data._this;
		const body = $('body');

		if ($('.btn-hamburger').hasClass('open')) {
			_this.hideWrapper(_this.overlay, body);
		} else {
			_this.showWrapper(_this.overlay, body);
		}
	}
	setListState(e) {
		e.preventDefault();
		if (!$(this).hasClass('open')) {
			$(this).addClass('open');
		} else {
			$(this).removeClass('open');
		}
	}
	hideWrapper(el, body,) {
		$(this.trigger).removeClass('open');
		$(this.header).removeClass('open');
		$(this.hamburgerTitle).text('Menu');
		$(el).removeClass('active');
		lockScroll.unlock();
		clearTimeout(Header.menuTimeout);
		$(this.animateElements).removeClass('active');
	}
	showWrapper(el, body,) {
		$(this.trigger).addClass('open');
		$(this.header).addClass('open');
		$(this.hamburgerTitle).text('Close');
		$(el).addClass('active');
		lockScroll.lock();
		Header.menuTimeout = setTimeout(() => {
			Header.animateItemsIn($(this.animateElements))

		}, 200);
	}
	resized() {
		this.setHeaderHeight();
		this.checkOverlay();
	}

	orientation() {
		if ($(this.overlayDesktop).hasClass('active')) {
			this.hideWrapper(this.overlayDesktop);
		}

		if ($(this.overlayMobile).hasClass('active')) {
			this.hideWrapper(this.overlayMobile);
		}
	}

	setHeaderHeight() {
		setTimeout(() => {
			$(this.overlay).css({
				'height': `${window.innerHeight - $('.main-header__container').height()}px`,
			})
		}, 10);
	}

	megaMenuHover() {
		$(this.megaMenuLinks).on({
			mouseenter: function (e) {
				const id = e.target.getAttribute('data-id');
				const img = $(`.main-header__overlay-content .menu a[data-id="${id}"]`).parent();
				img.addClass('active');
			},
			mouseleave: function (e) {
				const id = e.target.getAttribute('data-id');
				const img = $(`.main-header__overlay-content .menu a[data-id="${id}"]`).parent();
				img.removeClass('active');
			}
		});
	}

	static animateItemsIn(items) {
		let delay = 0;
		items.each((i, v) => {
			delay += 0.04;
			$(v).css('transition-delay', `${delay}s`);
			$(v).addClass('active');
		});
	}
}

export default new Header();
